import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useTranslations } from '../context/TranslationContext';

interface OfficeMapProps {
  googleMapsUrl: string;
}

export const OfficeMap: React.FC<OfficeMapProps> = ({ googleMapsUrl }) => {
  const { t } = useTranslations();

  return (
    <div className="space-y-4">
      <div className="relative h-[300px] w-full rounded-lg overflow-hidden border border-gray-200">
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d870.1338969036082!2d23.054010925725745!3d47.17920044683156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x474869fbb041eaa7%3A0x5626ed7e10ec51b8!2sCabinet%20de%20Avocat%20Kov%C3%A1cs%20Timea!5e0!3m2!1shu!2sdk!4v1737193455726!5m2!1shu!2sdk"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          title={t.map.title}
          className="absolute inset-0"
        />
      </div>
      <a 
        href={googleMapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center gap-2 w-full px-4 py-2 bg-[#597F70] text-white rounded-lg hover:bg-[#436557] transition-colors"
      >
        <span>{t.map.openInMaps}</span>
        <ExternalLink className="w-4 h-4" />
      </a>
    </div>
  );
};